import CONST from './Constant';

/**
 * Set the currently selected tool in Redux store
 * @param {Object} payload - Full tool object from TOOLS_CONFIG
 */
export const setSelectedTool = (payload) => ({
    type: CONST.SET_SELECTED,
    payload,
});

/**
 * Clear the currently selected tool
 */
export const clearSelectedTool = () => ({
    type: CONST.CLEAR_SELECTED,
});

